// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Radio.less';

let radioId = 0;

/**
 * Helper component for `FormFieldRadioButtons` component.
 */
class Radio extends Component {
    handleChange = event => {
        const { disabled, onChange } = this.props;
        if (!disabled && onChange) {
            onChange(event.target.checked);
        }
    };

    render() {
        const {
            baseClassName,
            className,
            children,
            onChange,
            checked,
            defaultChecked,
            disabled,
            inputProps,
            label,
            ...props
        } = this.props;

        if (!inputProps.id) {
            inputProps.id = `radio-${radioId++}`;
        }

        return (
            <div
                className={classNames(
                    baseClassName,
                    className,
                )}
                {...props}
            >
                <input
                    className={`${baseClassName}__input`}
                    type="radio"
                    onChange={this.handleChange}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    {...inputProps}
                />
                {label ? <label htmlFor={inputProps.id}>{label}</label> : null}
                {children}
            </div>
        );
    }
}

Radio.propTypes = {
    /**
     * Determine whether the `Radio` is checked.
     */
    checked: PropTypes.bool,
    /**
     * @ignore
     */
    defaultChecked: PropTypes.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    /**
     * Label of the `Radio`
     */
    label: PropTypes.node,
    /**
     * Additional content
     */
    children: PropTypes.node,
    /**
     * Additional props for input element
     */
    inputProps: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Radio.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    disabled: false,
    label: undefined,
    children: undefined,
    inputProps: {},
    className: undefined,
    baseClassName: `${CLS_PREFIX}radio`,
};

export default Radio;



// WEBPACK FOOTER //
// ./components/Radio/Radio.js